<template>
  <div class="slogan">
    <span v-for="(item,index) in sloganTxts">{{item}}</span>
    <div class="tabBack flex-center border" @click="$router.go(-1)">
      <span class="iconfont fanhui"></span>返回
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import Vue from 'vue'
import util from 'libs/util'
import helpers from 'dom-helpers';

export default {
  props: {},
  data() {
    return {
      sloganTxts:[]
    }
  },
  created() {
    this.getSlogan();
  },
  methods: {
    async getSlogan() {
      const uid = util.getStorage('llss_uid');
      const params = {
        key: uid
      };
      const res = await this.$post('/slogan/info.json', params);
      if (res.status == 200) {
        const data = res.data;
        if (data) {
          let txt = data.slogan || ''
          this.sloganTxts = txt.split('')
        }
      }
    }
  }
}

</script>
<style lang="less" scoped>
@import '~styles/mixin';
@import '~styles/var';
.tabBack {
    width: 80px;
    height: 52px;
    font-size: 14px;
    color: #666666;
    cursor: pointer;
    margin: 12px auto 0;
    border-top: 1px solid #EEEEEE;
    .iconfont {
      color: #57AE59;
      margin-right: 2px;
    }
  }
</style>
